import Aaron from "../../assets/aaron-circle.png";
import Lester from "../../assets/lester-circle.png";
import Paul from "../../assets/paul-circle.png";
import TeamCards from "./TeamCards";

const TheTeam = () => {
  return (
    <div className="grid grid-rows-3 md:grid-rows-1 md:grid-cols-3 gap-x-10">
      <TeamCards
        url={Lester}
        name="John Lester Talibong"
        text='"I take what is mine and take some more"'
        experience="A freelancer with a 5+ years experience focusing on video editing, graphic designing, and in customer service "
        position="CEO"
      />
      <TeamCards
        url={Paul}
        name="Paul Reselosa"
        text='"Success is not final, failure is not fatal."'
        experience="Started as a music video director that transitioned as a freelancer focusing in video editing"
        position="COO"
      />
      <TeamCards
        url={Aaron}
        name="Aaron Nim"
        text='"Programming enthusiast with an insatiable curiousity."'
        experience="Experienced in website development for 2 years, freelancer, and a corporate assistant"
        position="CTO"
      />
    </div>
  );
};

export default TheTeam;
